export const locale = {
  our_providers: 'Our Providers',
  providers: 'Providers',
};
